<template>
  <PageWrapper :active-page="PAGE_ONBOARDING_PENDING" :active-section="SECTION_ONBOARDING">
    <iRow align="center">
      <iColumn width="hug" align="left">
        <iHeader>Application In Progress</iHeader>
        <iDivider />
        <iSpace />

        <iParagraph>
          Thanks for submitting your application! We're reviewing it now and will get back to you soon.
          We're excited about the possibility of you joining us.
        </iParagraph>
      </iColumn>
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_ONBOARDING_PENDING, SECTION_ONBOARDING } from "@/constants/nav-constants";

export default {
  name: "CreatorPending",
  components: { PageWrapper },
  data() {
    return {
      SECTION_ONBOARDING,
      PAGE_ONBOARDING_PENDING,
    };
  },
};
</script>
